import { StyleSheet } from "react-native";
import { fonts } from "../../styles/theme";

const HomePageStyle = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: "#fff",

  },
  profileSection: {
    backgroundColor: "#3629B7",
    paddingVertical: 50,
    marginBottom: 10,
    paddingLeft: 20,
  },
  profileImage: {
    width: 80,
    height: 80,
    borderRadius: 40,
    marginBottom: 10,
  },
  profileName: {
    fontSize: 18,
    //fontWeight: "600",
    color: "#fff",
    fontFamily: fonts.regular,
    paddingLeft:4
  },
  profileEmail: {
    fontSize: 14,
    color: "#fff",
    fontFamily: fonts.regular,
    paddingLeft:4
  },
  menuSection: {
    // marginTop: 10,
    flexGrow: 1,
    justifyContent: "flex-start",
  },
  menuItem: {
    flexDirection: "row",
    alignItems: "center",
    padding: 10,
    paddingLeft: 20,
  },
  menuIcon: {
    width: 24,
    height: 24,
    marginRight: 20,
    tintColor: "#3629B7",
  },

  menuText: {
    fontSize: 20,
    color: "#333",
    fontFamily: fonts.regular,
  },
  zIndex3: {
    zIndex: 3,
  },
  imageContainer: {
    width: "100%",
    height: 80,
    backgroundColor: "#3629B7",
    position: "absolute",
    bottom: 0,
    left: 0,
    right: 0,
    paddingTop:10,
    paddingLeft:18
  },
});

export default HomePageStyle;
